import { createContext } from "react";

export const ProgressContext = createContext();
